// Zentraler Logger: Diagnose-Ausgaben nur in der Entwicklung.
// In der Produktion (NODE_ENV === 'production') sind log/warn no-ops,
// damit die Konsole nicht zugemüllt wird. Fehler werden immer ausgegeben.
const isDev = process.env.NODE_ENV !== 'production'

export default {
  log: (...args) => { if (isDev) console.log(...args) },
  warn: (...args) => { if (isDev) console.warn(...args) },
  info: (...args) => { if (isDev) console.info(...args) },
  error: (...args) => { console.error(...args) },
}
